module.exports = __webpack_public_path__ + "static/39gde-4fdb7433a56e62ed1e478fababf007a3.gif";